module.exports = __webpack_public_path__ + "static/img/25-box.e60b723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/25-box.png
// module id = QXmk
// module chunks = 0